import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import  CertRevokeUniquenoModel  from "../../models/certrevokeuniqueno";

class CertRevokeUniqueNoModal  extends Component {
    constructor() {
        super();
    
        this.state = {
          modalIsOpen: false,
          model:{
            CertificationRequestId:null,
            
          }
          
        };
    
        this.openModal = this.openModal.bind(this);
       
        this.closeModal = this.closeModal.bind(this);
        this.submit=this.submit.bind(this);
        this.refreshModel= this.refreshModel.bind(this);
        
      }
    
      openModal(id) {
        const {model}=this.state;
        model.CertificationRequestId=id;
       
        this.setState({modalIsOpen: true,model:model});
    

      }
     
     
      closeModal() {
        this.setState({modalIsOpen: false});
        
      }

      submit(){
        const {model}=this.state;  
        this.props.submitRevokeUniqueNoHandler(model);
        this.closeModal();
      }
      
      
      getData() {
          let model = new CertRevokeUniquenoModel(this.refs);
          return model;
      }

      refreshModel () {
        let _model = new CertRevokeUniquenoModel(this.refs);  
        this.setState({

            model:_model

        });

           
      }

    
      render() {
        const {model} = this.state;
        return (
           <Modal style={{opacity:1}} show={this.state.modalIsOpen} onHide={this.closeModal} centered size="md" aria-labelledby="contained-modal-title-vcenter" >
 
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                  ابطال شماره گواهی
                </Modal.Title>
            </Modal.Header>    
            <Modal.Body>
              <div className="form-horizontal">
                      <div class="form-group">
                          <label class="control-label col-sm-3" for="email">شماره گواهی جدید</label>
                          <div class="col-sm-9">
                              <input  className="form-control"  autoFocus   value={model && model.NewUniqueNo } onChange={this.refreshModel} type="number" name="NewUniqueNo" ref="NewUniqueNo"  />
                          </div>
                      </div>

                      <div class="form-group">
                          <label class="control-label col-sm-3" for="email">توضیحات</label>
                          <div class="col-sm-9">
                              <input  className="form-control" value={model && model.Description } onChange={this.refreshModel} type="text" name="Description" ref="Description"  />
                          </div>
                      </div>
                     
              </div>
              <input type="hidden" ref="CertificationRequestId" name="CertificationRequestId" value={model && model.CertificationRequestId}></input>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.closeModal}>
                انصراف
              </Button>
              <Button variant="primary" onClick={this.submit}>
                تایید
              </Button>
            </Modal.Footer>
          </Modal>
        );
      }
}

 
export default CertRevokeUniqueNoModal;